import { Query } from '@apollo/client/react/components'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { useParams, useLocation } from 'react-router-dom'

import { ErrorComponent, LoadingComponent, Node } from 'components'

import { query, queryLatest } from './Article.query.js'

import styles from './Article.module.css'

class ArticleInner extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    matchUrl: PropTypes.string.isRequired,
  }

  state = {}

  componentDidMount() {
    console.log(this.props)
    const q = queryString.parse(this.props.location.search)

    if (q.visual) {
      this.setState({ visual: q.visual })
    }
  }

  render() {
    const { params, matchUrl } = this.props

    return (
      <>
        {!params.latest ? (
          <Query query={query} variables={{ path: matchUrl }}>
            {({ loading, error, data }) => {
              if (loading) {
                return <LoadingComponent />
              }
              if (error) {
                console.log(error.message)
                return <ErrorComponent message={`Erro! ${error.message}`} />
              }
              if (!data.route) {
                return <ErrorComponent message='Página não encontrada' />
              }

              const { entity } = data.route

              return (
                <div className={styles.wrapper}>
                  <Node node={entity} visual={this.state.visual} />
                </div>
              )
            }}
          </Query>
        ) : (
          <Query
            query={queryLatest}
            variables={{
              nid: params.slug,
              revision: params.latest === 'latest' ? 'LATEST' : 'DEFAULT',
            }}
          >
            {({ loading, error, data }) => {
              if (loading) {
                return <LoadingComponent />
              }
              if (!loading && error) {
                return <ErrorComponent message={`Erro! ${error.message}`} />
              }
              if (!loading && !data.nodeQuery) {
                return <ErrorComponent message='Página não encontrada' />
              }
              if (!loading && !data.nodeQuery.entities[0]) {
                return <ErrorComponent message='Esse conteúdo não está disponível' />
              }

              const [entity] = data.nodeQuery.entities

              return (
                <div className={styles.wrapper}>
                  <Node node={entity} visual={this.state.visual} />
                </div>
              )
            }}
          </Query>
        )}
      </>
    )
  }
}

const Article = () => {
  const params = useParams()
  const location = useLocation()
  const matchUrl = params.latest ? `/node/${params.slug}/${params.latest}` : `/node/${params.slug}`

  return <ArticleInner params={params} location={location} matchUrl={matchUrl} />
}

export default Article
